import { clients } from "@/data/siteContent";

export default function Clients() {
  const row = [...clients.logos, ...clients.logos];
  return (
    <section
      className="relative overflow-hidden border-y border-white/10 bg-[#080808] py-12"
      data-testid="clients-section"
      aria-label="Capabilities"
    >
      <div className="mx-auto mb-8 max-w-[1400px] px-6 md:px-10">
        <p
          className="font-accent text-lg italic text-white/60"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          {clients.heading}
        </p>
      </div>

      <div className="marquee">
        <div className="marquee__track">
          {row.map((logo, i) => (
            <span
              key={i}
              className="mx-10 font-display text-2xl tracking-tight text-white/45 transition-colors hover:text-white/80 md:text-3xl"
              style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
            >
              {logo}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
